import AbstractDataLayerManager from './abstractDataLayerManager';
import { DataLayerItem } from 'Common/appshell_types/trackingHelpers';

class ClientDataLayerManager extends AbstractDataLayerManager {
    protected getRawDataLayer(): DataLayerItem[] {
        if (Array.isArray(window.dataLayer)) {
            return window.dataLayer as DataLayerItem[];
        }
        this.getLogger().warn('DataLayer is undefined', { source: 'GaTracking', dataLayer: window.dataLayer });
        return [];
    }

    public setPlatform(): this {
        return this;
    }
}

export default ClientDataLayerManager;
